import React, { useState, useEffect } from "react";
import { decryptToken } from "../utils/getToken";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { useNavigate } from "react-router-dom";
import { isInFilter } from "../utils/dateFilter";

// ✅ Status badge styles
const STATUS_STYLES = {
    Pending: "bg-yellow-200 text-yellow-700",
    Paid: "bg-green-200 text-green-700",
    Overdue: "bg-red-200 text-red-700",
};

export default function InvoiceSummary({filter}) {
    const navigate = useNavigate()
    const [invoice, setInvoice] = useState([]);
    const [loading, setLoading] = useState(true);
    const url = process.env.REACT_APP_LINK;
    const token = decryptToken("accessToken") || "";
    const user = getDecryptedUserFromCookie("gta_mainstateuser");


    const fetchInvoice = async () => {
        try {
            const res = await fetch(`${url}/newinvoice/all/${user.main_id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const data = await res.json();
            setInvoice(Array.isArray(data) ? [...data].reverse() : []);
        } catch (error) {
            console.error("❌ Fetch invoice failed:", error);
        } finally {
            setLoading(false);
        }
    };

    const filteredInvoices = invoice.filter(i =>
        isInFilter(i.createdAt, filter)
    );


    useEffect(() => {
        if (token) fetchInvoice();
    }, [token]);

    return (
        <div>
            <div className="flex justify-between gap-2 items-center mb-3">
                <h2 className="text-[20px] font-bold text-[#222] ">
                    Invoice Summary
                </h2>
                <button
                    onClick={() => navigate('/invoice')}
                    className="text-xs px-2 py-1 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-600 hover:text-white transition">
                    View more
                </button>
            </div>

            <div className="bg-gray-50 rounded p-2 min-h-[120px] flex items-center justify-center">
                {loading ? (
                    <p className="text-gray-500 text-sm animate-pulse">
                        Loading invoice...
                    </p>
                ) : invoice.length === 0 ? (
                    <p className="text-gray-500 text-sm">No invoice found.</p>
                ) : (
                    <table className="w-full text-sm">
                        <thead className="font-semibold text-gray-700">
                            <tr>
                                <th className="text-left py-1">Customer</th>
                                <th className="text-left py-1">Price</th>
                                <th className="text-center py-1">Status</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredInvoices.slice(0, 10).map((invoice, index) => {
                                return (
                                    <tr key={index} className="border-t">
                                        <td className="py-2 text-gray-700">
                                            {invoice.customer_name
                                                ? invoice.customer_name.slice(0, 15) + (invoice.customer_name.length > 15 ? "…" : "")
                                                : "-"}
                                        </td>

                                        <td className="py-2 text-left text-gray-800">
                                            ₹{invoice.status === "Paid" ? invoice.subtotal : invoice.pending}
                                        </td>

                                        <td className="py-2 text-center">
                                            <span
                                                className={`px-2 py-1 rounded-full text-xs font-medium ${STATUS_STYLES[invoice.status] ||
                                                    "bg-gray-200 text-gray-700"
                                                    }`}
                                            >
                                                {invoice.status}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
